// extracted by mini-css-extract-plugin
export default {"HeroItem":"HeroItem_HeroItem__7g-uf","HeroItemText":"HeroItem_HeroItemText__JQg-y"};